import {
  getCart,
  addCart,
  delCart,
  editQuantity,
  submitVerify
} from "@/api/cart/cart";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    // 获取进货车列表
    async getCart(context, params) {
      console.log(params);
      const { data } = await getCart(params);
      return data;
    },

    // 添加进货车
    async addCart(context, params) {
      console.log(params);
      const { data } = await addCart(params);
      return data;
    },

    // 删除进货车
    async delCart(context, params) {
      console.log(params);
      const res = await delCart(params);
      return res;
    },

    // 添加进货车
    async editQuantity(context, params) {
      console.log(params);
      const res = await editQuantity(params);
      console.log(res);
      return res;
    },

    // 校验进货车
    async submitVerify(context, params) {
      const res = await submitVerify(params);
      return res;
    }
  }
};
